import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {Currency, PriceInterval, PriceType, Product} from '../__generated__/resolvers-types';
import {env} from '../constants';

const GET_PRODUCTS_QUERY = gql`
  query GetProducts {
    getProducts {
      id
      name
      description
      active
      role
      features
      quotas
      prices {
        id
        unitAmount
        currency
        type
        interval
        intervalCount
      }
    }
  }
`;

const freeProduct: Product = {
  id: env.defaultStripeRole,
  name: 'Free',
  description: 'Free plan',
  active: true,
  role: env.defaultStripeRole,
  features: ['Try out all features with limited usage'],
  quotas: [''],
  prices: [
    {
      active: true,
      currency: Currency.gbp,
      id: 'free-monthly',
      interval: PriceInterval.month,
      type: PriceType.recurring,
      unitAmount: 0,
    },
    {
      active: true,
      currency: Currency.gbp,
      id: 'free-yearly',
      interval: PriceInterval.year,
      type: PriceType.recurring,
      unitAmount: 0,
    },
  ],
};

export default function useGetProducts() {
  const {data, loading, error} = useQuery<{getProducts: Product[]}>(GET_PRODUCTS_QUERY);

  return {
    products: [freeProduct, ...(data?.getProducts || [])],
    loading,
    error,
  };
}
